{
  "version": 1,
  "asset_id": "6bf1fc7e-0a61-4134-8edc-de8b7ddc25fb",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/6bf1fc7e-0a61-4134-8edc-de8b7ddc25fb/lecanto-black-shingle-roof-1320w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/6bf1fc7e-0a61-4134-8edc-de8b7ddc25fb/lecanto-black-shingle-roof-1320w.webp",
  "original_filename": "lecanto-black-shingle-roof-1320w.webp",
  "size": 394160,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:57Z"
}
